import { useEffect, useState } from "react";
import refer from "../../assets/refer.png";
import addfriend from "../../assets/add_friend.png";
import image2 from "../../assets/image_right_shadow.png";
import image1 from "../../assets/image_left_shadow.png";
import button1 from "../../assets/octicon_cross-reference-16.png";
import button2 from "../../assets/carbon_copy-link.png";
import axios from "axios";
import { toast } from "react-toastify";
import { Theme } from '../../lib/theme';

interface ReferralPageProps {
  userPlan: string; // Accept userPlan as a prop
  referredByOrgId: string | null;
  referredByUserId: string | null;
}



export default function ReferralPage({ userPlan }: ReferralPageProps) {
  const [currency, setCurrency] = useState("INR");
  const [freeCredit, setFreeCredit] = useState(250);
  const [proCredit, setProCredit] = useState(500);
  const [referralEmail, setReferralEmail] = useState("");

  const authToken = sessionStorage.getItem("authToken");
  const orgId = sessionStorage.getItem("orgId");
  const userId = sessionStorage.getItem("userEmail"); 
  const [referralLink, setReferralLink] = useState<string | null>(null);
  const [copySuccess, setCopySuccess] = useState(false);
  const [successfulReferrals, setSuccessfulReferrals] = useState(0);
  const [referralCredits, setReferralCredits] = useState(0)
 
 

  const handleEmailClick = async () => {
    if (!orgId || !userId) {
      alert("Missing organization ID or user ID.");
      return;
    }
  
    try {
      // Step 1: Generate Referral Link
      const response = await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/referral/generate-referral`,
        { orgId, userId },
        { headers: { Authorization: `Bearer ${authToken}` } }
      );
  
      const link = response.data.referralLink;
      setReferralLink(link); // Store the referral link in state
  
      // Step 2: Get user details from session storage
      const userEmail = sessionStorage.getItem("userEmail");
      const referrerName = sessionStorage.getItem("referrerName");
  
      if (!userEmail || !referrerName) {
        console.error("User email or referrer name is missing in session storage.");
        return;
      }
  
      // Step 3: Format multiple email recipients
      const emailList = referralEmail.split(",").map(email => email.trim()).filter(email => email);
  
      if (emailList.length === 0) {
        toast.error("Please enter a valid email.");
        return;
      }
  
      // Step 4: Send Referral Emails
      await axios.post(
        `https://d3rodhz1nayiby.cloudfront.net/api/emails/queue-referral-email`,
        {
          emails: emailList.map(email => ({
            userName: userEmail,
            recipient: email,
            signupLink: link,
            referrerName: referrerName,
          })),
        }
      );

      toast.success("Referral email(s) sent successfully!");
      setReferralEmail(""); // Clear the input field after sending
    } catch (error) {
      console.error("Error handling referral process:", error);
      toast.error("Failed to send referral emails.");
    }
  };
  
  const fetchReferralData = async () => {
    if (!orgId || !authToken) {
      console.error("Missing orgId or authToken");
      return;
    }
  
    try {
      console.log("Auth Token:", authToken);
  
      const response = await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organizationedit/${orgId}`,
        { orgId, userId },
        {
          headers: { Authorization: `Bearer ${authToken}` }, // ✅ Correct header placement
        }
      );
  
      const { successfulReferrals = 0, credits = 0 } = response.data;
      setSuccessfulReferrals(successfulReferrals);
      setReferralCredits(credits);
    } catch (error) {
      console.error(
        "Error fetching referral data:",
        axios.isAxiosError(error) ? error.response?.data || error.message : error
      );
    }
  };
  
  // Call function on page load
  useEffect(() => {
    fetchReferralData();
  }, []);
 console.log("userPlan", userPlan);
  useEffect(() => {
    async function fetchIpInfo() {
      try {
        const response = await fetch("https://api.zynth.ai/api/v1/data/userprofile/ip-info");
        const data = await response.json();
        const country = data?.country || "IN";

        if (country === "US") {
          setCurrency("USD");
          setFreeCredit(4.5);
          setProCredit(9.5);
        } else if (country === "EU") {
          setCurrency("EUR");
          setFreeCredit(4.2);
          setProCredit(9.0);
        } else {
          setCurrency("INR");
          setFreeCredit(250);
          setProCredit(500);
        }
      } catch (error) {
        console.error("Error fetching IP info:", error);
      }
    }

    fetchIpInfo();
  }, []);
  
  
  const handleReferralClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  
    if (!orgId || !userId) {
      toast.error("Missing organization ID or user ID.");
      return;
    }
  
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/referral/generate-referral`,
        { orgId, userId },
        { headers: { Authorization: `Bearer ${authToken}` } }
      );
  
      const link = response.data.referralLink;
  
      if (link) {
        setReferralLink(link);
  
        // First try Clipboard API
        if (navigator.clipboard && window.isSecureContext) {
          try {
            await navigator.clipboard.writeText(link);
            toast.success("Referral link copied to clipboard!");
          } catch (err) {
            console.warn("Clipboard API failed, using fallback:", err);
            copyToClipboardFallback(link);
          }
        } else {
          // Fallback for Safari/iOS
          copyToClipboardFallback(link);
        }
  
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000);
      }
    } catch (error) {
      console.error("Error generating referral link:", error);
      toast.error("Failed to generate referral link.");
    }
  };
  
  // **Fallback for iPhone/Safari**
  const copyToClipboardFallback = (text: string) => {
    const textField = document.createElement("textarea");
    textField.value = text;
    document.body.appendChild(textField);
    textField.select();
    textField.setSelectionRange(0, textField.value.length); // Ensure proper selection
    document.execCommand("copy");
    document.body.removeChild(textField);
    toast.success("Referral link copied to clipboard! (fallback method)");
  };
  
  return (
<div
  className="min-h-screen flex flex-col items-center py-6 px-4"
  style={{ backgroundColor: Theme.colors.stroke.weak }}
>
  <h1 className="text-2xl font-bold text-center flex items-center gap-2">
    🎉 INVITE & EARN WITH ZYNTH!
  </h1>

  <p
    className="font-light text-sm text-center mt-4"
    style={{ color: Theme.colors.text.default }}
  >
    Love using Zynth? Share it with your friends and unlock exclusive rewards! 🚀
  </p>
  <p
    className="font-light text-sm text-center mt-2"
    style={{ color: Theme.colors.text.default }}
  >
    ✅ Share Your Unique Link – Invite friends to try Zynth.
  </p>
  <p
    className="font-light text-sm text-center mt-2"
    style={{ color: Theme.colors.text.default }}
  >
    ✅ They Sign Up & Use Zynth – Your friend generates and exports a presentation.
  </p>
  <p
    className="font-light text-sm text-center mt-2"
    style={{ color: Theme.colors.text.default }}
  >
    ✅ You Get Rewarded! – Earn discounted exports.
  </p>

  <div className="mt-8 flex flex-col md:flex-row gap-6">
    {/* Refer a Friend */}
    <div
      className="shadow-lg rounded-2xl p-6 w-full md:w-96"
      style={{ backgroundColor: Theme.colors.background }}
    >
      <img src={addfriend} alt="Refer a Friend" className="w-12 mx-auto" />
      <h2 className="text-xl font-bold text-center mt-4">REFER A FRIEND</h2>
      <p
        className="text-center font-normal text-sm mt-2"
        style={{ color: Theme.colors.text.weak }}
      >
        Send a referral email or copy the referral link and share with your friends.
      </p>

      <input
        type="email"
        placeholder="Friend’s email"
        value={referralEmail}
        onChange={(e) => setReferralEmail(e.target.value)}
        className="w-full mt-4 p-3 text-xs rounded-lg focus:outline-none focus:ring-2"
        style={{
          backgroundColor: Theme.colors.stroke.weak,
          border: `1px solid ${Theme.colors.stroke.weak}`,
          color: `${Theme.colors.text.weak}AA`,
          caretColor: Theme.colors.primary,
          boxShadow: 'none',
        }}
      />

      <div className="flex gap-4 mt-4 justify-between p-2">
        <button
          disabled={referralEmail.length === 0}
          className={`flex flex-row w-[50%] items-center justify-center gap-2 py-2 text-sm rounded-lg shadow transition ${
            referralEmail.length === 0
              ? 'bg-gray-400 border-gray-400 text-gray-200 cursor-not-allowed'
              : 'cursor-pointer'
          }`}
          style={
            referralEmail.length === 0
              ? {}
              : {
                  backgroundColor: Theme.colors.primary,
                  color: Theme.colors.background,
                  border: `1px solid ${Theme.colors.primary}`,
                }
          }
          onClick={handleEmailClick}
        >
          <img src={button1} alt="Refer a Friend" className="w-4" />
          Send Email
        </button>

        <button
          className="flex flex-row w-[50%] items-center justify-center gap-2 text-black py-3 text-sm rounded-lg shadow transition"
          style={{
            backgroundColor: Theme.colors.stroke.weak,
          }}
          onClick={handleReferralClick}
        >
          <img src={button2} alt="Copy Link" className="w-4" />
          {copySuccess ? 'Copied!' : 'Copy Link'}
        </button>
      </div>
    </div>

    {/* Rewards */}
    <div
      className="shadow-lg rounded-2xl p-6 w-full md:w-96 relative"
      style={{ backgroundColor: Theme.colors.background }}
    >
      <img src={image1} alt="Shadow Left" className="absolute left-4 top-6 w-20" />
      <img src={image2} alt="Shadow Right" className="absolute right-4 top-6 w-20" />
      <img src={refer} alt="Rewards" className="w-12 mx-auto" />
      <h2 className="text-xl font-bold text-center mt-4">REWARDS</h2>
      <p
        className="text-center font-normal text-sm mt-2"
        style={{ color: Theme.colors.text.weak }}
      >
        Earn 1 credit for every successful referral.
      </p>
      <p
        className="text-center font-normal text-sm mt-10"
        style={{ color: Theme.colors.text.weak }}
      >
        1 credit = {currency} {userPlan === 'free' ? freeCredit : proCredit}
      </p>

      <div className="flex justify-between mt-3">
        <div className="text-center">
          <p className="text-xs p-2" style={{ color: Theme.colors.text.weak }}>
            Successful Referrals
          </p>
          <div
            className="p-1 rounded-lg text-lg font-bold min-w-[50px] min-h-[40px] flex items-center justify-center"
            style={{
              backgroundColor: Theme.colors.background,
              border: `1px solid ${Theme.colors.stroke.weak}`,
              color: Theme.colors.text.default,
            }}
          >
            {successfulReferrals}
          </div>
        </div>
        <div className="text-center">
          <p className="text-xs p-2" style={{ color: Theme.colors.text.weak }}>
            Referral Credits Left
          </p>
          <div
            className="p-1 rounded-lg text-lg font-bold min-w-[50px] min-h-[40px] flex items-center justify-center"
            style={{
              backgroundColor: Theme.colors.background,
              border: `1px solid ${Theme.colors.stroke.weak}`,
              color: Theme.colors.text.default,
            }}
          >
            {referralCredits}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

  
  );
}
